import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BackButton from '../components/BackButton';
import UserBadge from '../components/UserBadge';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiRequest, UPLOADS_BASE_URL } from '../config/api';

interface NewsEntry {
  _id: string;
  title: string;
  content: string;
  category: string;
  image?: string;
  authorid: string;
  publishedAt: string;
  createdAt: string;
}

const NewsDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [entry, setEntry] = useState<NewsEntry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEntry = async () => {
      try {
        const response = await apiRequest(`/news/${id}`);
        if (!response.ok) throw new Error('Meldung nicht gefunden');
        const data = await response.json();
        setEntry(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Fehler beim Laden');
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchEntry();
  }, [id]);

  const formatDate = (dateString: string) =>
    new Date(dateString).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

  if (loading) {
    return (
      <div className="container">
        <LoadingSpinner message="Lade Meldung..." fullPage />
      </div>
    );
  }

  if (error || !entry) {
    return (
      <div className="container" style={{ padding: '40px' }}>
        <div className="alert alert-danger">{error || 'Meldung nicht gefunden'}</div>
        <BackButton to="/news" label="Zurück zu Aktuelle Meldungen" />
      </div>
    );
  }

  return (
    <div className="container" style={{ padding: '40px' }}>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <BackButton to="/news" label="Aktuelle Meldungen" />
        <UserBadge />
      </div>

      <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
        <div className="card-body p-4">
          {/* Title */}
          <h4 style={{ color: '#0d6efd', fontWeight: 700, marginBottom: '8px' }}>
            {entry.title}
          </h4>

          {/* Meta */}
          <p style={{ color: '#a0afc0', fontSize: '13px', marginBottom: '20px' }}>
            {formatDate(entry.publishedAt || entry.createdAt)} · Kategorie {entry.category}
          </p>

          {/* Image */}
          {entry.image && (
            <img
              src={`${UPLOADS_BASE_URL}${entry.image}`}
              alt={entry.title}
              style={{
                width: '100%',
                maxHeight: '400px',
                objectFit: 'cover',
                borderRadius: '8px',
                marginBottom: '20px',
              }}
            />
          )}

          {/* Content */}
          <p style={{ color: '#687088', fontSize: '15px', lineHeight: '1.7', whiteSpace: 'pre-wrap' }}>
            {entry.content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;
